// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// const SimilarNavBar = ({ onSearch,singleCard }) => {
//   const [selectedAttributes, setSelectedAttributes] = useState([]);
//   const [attributes, setAttributes] = useState([]);
// console.log('single card',singleCard)

// useEffect(() => {
//   console.log('singleCard',singleCard)
//   setAttributes(
//     [ singleCard.Name.toString(),
//   singleCard.YearMade.toString(),
//   singleCard.SetName.toString(),
//   singleCard.variationName.toString(),
//   singleCard.cardName.toString(),])
// }, [singleCard]);
// const fetchSimilarResult = async (inputValue) => {
    
//     try {
//       const response = await axios.get(`${process.env.REACT_APP_API_BASE}/api/searchbar/DeepSearch/GetSimilar?searchTerm=${inputValue}`);
      
//       const suggestions = response.data;
//       console.log('0000 suggestion', suggestions);
//       return suggestions || []; // Return the array of suggestions or an empty array
//     } catch (error) {
//       console.error('Error fetching suggestions: v2', error);
//       return []; // Return an empty array in case of an error
    
//   }
//   };

//   const handleCheckboxChange = (attribute) => {
//     setSelectedAttributes((prevSelected) => {
//       if (prevSelected.includes(attribute)) {
//         console.log('already selected',attribute)
//         return prevSelected.filter((selected) => selected !== attribute);
//       } else {
//         console.log('adding to SelectedAttribut',attribute)
//         return [...prevSelected, attribute];
//       }
//     });
//   };

//   const handleSearch = () => {
//      // Prevent event propagation to avoid multiple triggers
//      const result = selectedAttributes.join(' ');
//      const fetchResult =  fetchSimilarResult(result);
//      console.log('result',result);
//     onSearch(fetchResult);
//     console.log('completed?')
//   };

//   const handleAttributeClick = async (attribute, event) => {
//     // Prevent event propagation to avoid multiple triggers
//     console.log(attribute);
  
//     try {
//       const fetchResult = await fetchSimilarResult(attribute);
//       console.log('you clicked on', attribute);
//       console.log('fetchResult', fetchResult);
//       // Now you can use fetchResult here
//        onSearch(fetchResult);
//     } catch (error) {
//       console.error('Error handling attribute click:', error);
//     }
//   };

//   useEffect(() => {
//     console.log('Selected Attributes:', selectedAttributes);
//   }, [selectedAttributes]);

//   return (
//     <div className="similar-nav-bar">
//       <h2>Search Attributes</h2>
//       <div className="attributes-container">
//         {attributes.map((attribute, index) => (
//           <label key={index} className="attribute-item">
//             <input
//               type="checkbox"
//               checked={selectedAttributes.includes(attribute)}
//               onChange={() => handleCheckboxChange(attribute)}
//             />
//             <span className="attribute-text">{attribute}</span>
//           </label>
//         ))}
//       </div>
//       <button className="search-button" onClick={handleSearch}>
//         Search
//       </button>
//     </div>
//   );
// };

// SimilarNavBar.propTypes = {
//   onSearch: PropTypes.func.isRequired,
//   singleCard: PropTypes.object.isRequired,
// };
// export default SimilarNavBar;

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';

const SimilarNavBar = ({ onSearch, singleCard,t }) => {
  const [selectedAttributes, setSelectedAttributes] = useState([]);
  const [attributes, setAttributes] = useState([]);

  useEffect(() => {
    if (singleCard) {
      console.log('singleCard', singleCard);
      
      const attributes = [
        singleCard.Name?.toString() || '',
        singleCard.YearMade?.toString() || '',
        singleCard.SetName?.toString() || '',
        singleCard.cardName?.toString() || '',
        singleCard.variationName?.toString() || ''
      ];
  
      // Conditionally add extra attributes only if they match the criteria
      if (singleCard.IsRookie?.toString() === 'Rookie(RC)') attributes.push('Rookie');
      if (singleCard.IsAuto?.toString() === 'Auto') attributes.push('Auto');
      if (singleCard.IsJersey?.toString() === 'Jersey') attributes.push('Jersey');
      if (singleCard.IsPatch?.toString() === 'Patch') attributes.push('Patch');
  
      setAttributes(attributes);
    }
  }, [singleCard]);
  

  const fetchSimilarResult = async (inputValue) => {
    try {
      // const response = await axios.get(`${process.env.REACT_APP_API_BASE}/api/searchbar/DeepSearch/GetSellingsCards?searchTerm=${inputValue}`);
      const response = await axios.get(`${process.env.REACT_APP_API_BASE}/api/searchbar/SearchBar?searchTerm=${inputValue}`);
     
      return response.data || [];
    } catch (error) {
      console.error('Error fetching similar results:', error);
      return [];
    }
  };

  const handleCheckboxChange = (attribute) => {
    setSelectedAttributes((prevSelected) =>
      prevSelected.includes(attribute)
        ? prevSelected.filter((item) => item !== attribute)
        : [...prevSelected, attribute]
    );
  };

  const handleSearch = async () => {
    if (selectedAttributes.length > 0) {
      const query = selectedAttributes.join(' ');
      const fetchResult = await fetchSimilarResult(query);
      onSearch(fetchResult);
    }
  };

  return (
    <div className="similar-nav-bar">
      <h3>{t('Search Attributes')}</h3>
      <div className='flex-h' style={{paddingBottom:'0px'}}>
      <div className="attributes-container">
        {attributes.map((attribute, index) => (
          <label key={index} className="attribute-item">
            <input
              type="checkbox"
              checked={selectedAttributes.includes(attribute)}
              onChange={() => handleCheckboxChange(attribute)}
            />
            <p className="attribute-text">{attribute}</p>
          </label>
        ))}
      </div>
      <button className="search-button"  onClick={handleSearch}>
        {t('Find')}
      </button>
    </div>
    </div>
  );
};

SimilarNavBar.propTypes = {
  onSearch: PropTypes.func.isRequired,
  singleCard: PropTypes.object.isRequired,
};

export default SimilarNavBar;
